import baixa from '@/repositories/conecta-sus/almoxarifado/baixaRepository'
import balancete from '@/repositories/conecta-sus/almoxarifado/balanceteRepository'
import dispensacaoMateriais from './dispensacaoMateriaisRepository'
import entrada from '@/repositories/conecta-sus/almoxarifado/entradaRepository'
import entradaInicial from '@/repositories/conecta-sus/almoxarifado/entradaInicialRepository'
import inventario from '@/repositories/conecta-sus/almoxarifado/inventarioRepository'
import motivoBaixa from '@/repositories/conecta-sus/almoxarifado/motivoBaixaRepository'
import parametrizacao from '@/repositories/conecta-sus/almoxarifado/parametrizacaoRepository'
import relatorioConsumoFinanceiro from '@/repositories/conecta-sus/almoxarifado/relatorioConsumoFinanceiroRepository'
import relatorioConsumoMedioMensal from '@/repositories/conecta-sus/almoxarifado/relatorioConsumoMedioMensalRepository'
import relatorioEntrada from '@/repositories/conecta-sus/almoxarifado/relatorioEntradaRepository'
import relatorioEstornoEntrada from '@/repositories/conecta-sus/almoxarifado/relatorioEstornoEntradaRepository'
import relatorioEstornoSaida from '@/repositories/conecta-sus/almoxarifado/relatorioEstornoSaidaRepository'
import relatorioMovimentacaoGeral from '@/repositories/conecta-sus/almoxarifado/relatorioMovimentacaoGeralRepository'
import relatorioPosicaoEstoque from './relatorioPosicaoEstoqueRepository'
import relatorioRequisicao from '@/repositories/conecta-sus/almoxarifado/relatorioRequisicaoRepository'
import relatorioSaida from '@/repositories/conecta-sus/almoxarifado/relatorioSaidaRepository'
import relatorioValidadeMaterial from '@/repositories/conecta-sus/almoxarifado/relatorioValidadeMaterialRepository'
import requisicaoAberturaFechamento from '@/repositories/conecta-sus/almoxarifado/requisicaoAberturaFechamentoRepository'
import requisicaoPendentePermissao from '@/repositories/conecta-sus/almoxarifado/requisicaoPendentePermissaoRepository'
import saida from '@/repositories/conecta-sus/almoxarifado/saidaRepository'
import transferencia from '@/repositories/conecta-sus/almoxarifado/transferenciaRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/almoxarifado`

    return {
        baixa: baixa(baseUrl),
        balancete: balancete(baseUrl),
        dispensacaoMateriais: dispensacaoMateriais(baseUrl),
        entrada: entrada(baseUrl),
        entradaInicial: entradaInicial(baseUrl),
        inventario: inventario(baseUrl),
        motivoBaixa: motivoBaixa(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioConsumoFinanceiro:relatorioConsumoFinanceiro(baseUrl),
        relatorioConsumoMedioMensal: relatorioConsumoMedioMensal(baseUrl),
        relatorioEntrada:relatorioEntrada(baseUrl),
        relatorioEstornoEntrada: relatorioEstornoEntrada(baseUrl),
        relatorioEstornoSaida: relatorioEstornoSaida(baseUrl),
        relatorioMovimentacaoGeral: relatorioMovimentacaoGeral(baseUrl),
        relatorioPosicaoEstoque: relatorioPosicaoEstoque(baseUrl),
        relatorioRequisicao: relatorioRequisicao(baseUrl),
        relatorioSaida: relatorioSaida(baseUrl),
        relatorioValidadeMaterial: relatorioValidadeMaterial(baseUrl),
        requisicaoAberturaFechamento: requisicaoAberturaFechamento(baseUrl),
        requisicaoPendentePermissao: requisicaoPendentePermissao(baseUrl),
        saida: saida(baseUrl),
        transferencia: transferencia(baseUrl),
    }
}